import { render, staticRenderFns } from "./Dsr.vue?vue&type=template&id=632be3f2&"
import script from "./Dsr.vue?vue&type=script&lang=js&"
export * from "./Dsr.vue?vue&type=script&lang=js&"
import style0 from "./Dsr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports